import axios from "axios";
import cookie from "js-cookie";
const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  //   timeout: 1000,
  //   headers: { "X-Custom-Header": "foobar" },
});
let token1 = cookie.get("token");
console.log(token1);

instance.interceptors.request.use(
  async (config) => {
    config.headers = {
      Authorization: cookie.get("token")
        ? `Bearer` + " " + cookie.get("token")
        : "",
    };
    return config;
  },
  (error) => Promise.reject(error)
);
axios.defaults.headers.post["Authorization"] = `Bearer + ${cookie.get(
  "token"
)}`;

instance.defaults.headers.common["Content-Type"] = "application/json";

export default instance;
